const phoneRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;

export const phoneFormat = (value: string): string =>
  value.replace(phoneRegex, "($1) $2-$3");
